import Styled from 'styled-components';

const ContactsPage = Styled.div`
    min-height: 100%;
    overflow-x: hidden;
    background: #f6f7fb;

    @media only screen and (max-width: 767px){
        .ant-page-header,
        .ant-card-toolbox{
            padding: 16px 16px 8px;
            background: #f6f7fb;
        }
        .ant-page-header-heading{
            display: flex !important;
            flex-flow: row wrap !important;
            align-items: center !important;
            justify-content: space-between !important;
            gap: 12px;
        }
        .ant-page-header-heading-left{
            min-width: 0;
            margin: 0 !important;
            width: 100% !important;
        }
        .ant-page-header-heading-title,
        .ant-page-header-heading .ant-page-header-heading-title{
            font-size: 22px;
            line-height: 1.25;
            color: #20253a;
            font-weight: 700;
            white-space: normal;
            text-align: left !important;
        }

        .ant-page-header-heading-sub-title{
            display: block;
            max-width: none;
            margin: 8px 0 0;
        }
        .ant-page-header-heading-sub-title .ant-select,
        .ant-page-header-heading-sub-title .ant-input,
        .ant-page-header-heading-sub-title input{
            width: 100% !important;
        }
        .ant-page-header-heading-extra{
            float: none;
            margin: 0 !important;
            display: block !important;
            width: 100% !important;
        }
        .page-header-actions{
            display: flex;
            width: 100%;
            flex-wrap: wrap;
            gap: 8px;
        }
        .page-header-actions .ant-btn{
            height: 36px;
            padding: 0 14px;
            border-radius: 6px !important;
            font-size: 13px;
        }
        .ant-breadcrumb{
            display: flex;
            min-width: 0;
            overflow-x: auto;
            white-space: nowrap;
        }
        .contacts-main{
            min-height: 0;
            width: 100%;
            padding: 12px 16px 24px;
            box-sizing: border-box;
            background: #f6f7fb;
        }
        .contacts-main .ant-row > .ant-col{
            min-width: 0;
        }
        .contacts-main .ant-card{
            width: 100%;
            overflow: hidden;
            margin-bottom: 14px !important;
            border: 1px solid #edf0f5;
            border-radius: 10px !important;
            background: #fff;
            box-shadow: 0 4px 12px rgba(31, 39, 79, 0.04);
        }
        .contacts-main .ant-card-head{
            min-height: 0;
            padding: 0 16px;
        }
        .contacts-main .ant-card-head-wrapper{
            display: block;
        }
        .contacts-main .ant-card-head-title{
            padding: 14px 0 8px;
            font-size: 16px;
            font-weight: 700;
            text-align: left !important;
        }
        .contacts-main .ant-card-extra{
            float: none;
            max-width: 100%;
            padding: 0 0 12px;
        }
        .contacts-main .ant-card-extra > .ant-space{
            display: flex;
            flex-wrap: wrap;
            gap: 8px !important;
        }
        .contacts-main .ant-card-extra .ant-btn{
            height: 34px;
            padding: 0 10px;
            border-radius: 6px !important;
        }
        .contacts-main .ant-card-body{
            padding: 12px !important;
        }
        .contacts-main .table-responsive{
            width: 100%;
            overflow-x: visible;
        }
        .contacts-main .ant-table-wrapper,
        .contacts-main .ant-spin-nested-loading,
        .contacts-main .ant-spin-container{
            width: 100%;
            max-width: 100%;
        }
        .contacts-main .ant-table{
            width: 100%;
        }
        .contacts-main .ant-table-content{
            overflow-x: auto !important;
            -webkit-overflow-scrolling: touch;
        }
        .contacts-main .ant-table-content table{
            min-width: 720px !important;
        }
        .contacts-main .active-contacts-table .ant-table-content table{
            min-width: 920px !important;
        }


        .contacts-main .ant-table-container{
            border: 1px solid #edf0f5;
            border-radius: 0;
        }

        .contacts-main .ant-table-thead > tr > th{
            padding: 12px;
            background: #f7f8fa;
            color: #59617f;
            font-size: 12px;
            font-weight: 700;
            white-space: nowrap;
        }
        .contacts-main .ant-table-tbody > tr > td{
            padding: 12px;
            color: #303750;
            font-size: 13px;
            vertical-align: middle;
        }
        /* Keep every contact field available on phones through one horizontal table scroll. */
        .contacts-main .active-contacts-table .ant-table{
            width: 100% !important;
            min-width: 0 !important;
        }
        .contacts-main .active-contacts-table .ant-table-content table{
            min-width: 920px !important;
        }
        .contacts-main .active-contacts-table .ant-table-thead > tr > th:nth-child(1),
        .contacts-main .active-contacts-table .ant-table-tbody > tr > td:nth-child(1){
            width: 42px;
            padding-right: 6px;
            padding-left: 10px;
        }
        .contacts-main .ant-pagination{
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            margin: 14px 8px;
        }
        .contacts-main .ant-tabs-nav{
            margin: 0 0 12px !important;
            overflow-x: auto;
        }
        .contacts-main .ant-tabs-nav-list{
            min-width: max-content;
        }
        .contacts-main .ant-tabs-tab{
            padding: 10px 8px;
            font-size: 13px;
            font-weight: 600;
        }

        .contact-details-main .ant-row > .ant-col{
            width: 100%;
            max-width: 100%;
            flex: 0 0 100%;
        }
        .contacts-main .ant-modal{
            max-width: calc(100vw - 32px);
        }

        /* Full width SidePanel drawer on mobile */
        .ant-drawer-content-wrapper,
        .ant-drawer-right .ant-drawer-content-wrapper{
            width: 100% !important;
            max-width: 100% !important;
        }
    }
`;

export { ContactsPage };
